import { useEffect, useState } from "react";
import api from "../services/api-service";
import { useAlert } from "../contexts/AlertContext";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import "../styles/users.css";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingUserId, setUpdatingUserId] = useState(null);
  const [error, setError] = useState("");
  const { showAlert } = useAlert();
  const { user } = useContext(AuthContext);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await api.get("/users");
      setUsers((prev) => [...prev, ...res.data]);
    } catch (err) {
      console.error("Failed to fetch users", err);
      setError("Failed to load users.");
    } finally {
      setLoading(false);
    }
  };

  const fetchModerators = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await api.get("/users/moderators");
      setUsers((prev) => [...prev, ...res.data]);
    } catch (err) {
      console.error("Failed to fetch moderators", err);
      setError("Failed to load moderators.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    user?.role === "ADMIN" && fetchModerators();
  }, [user?.role]);

  const handleToggleStatus = async (user) => {
    const userStatus = user.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    try {
      setUpdatingUserId(user.id);

      await api.put(`/users/status/${user.id}`, { userStatus });

      setUsers((prev) =>
        prev.map((u) => (u.id === user.id ? { ...u, status: userStatus } : u)),
      );
    } catch (err) {
      console.error("Failed to update user status", err);
      showAlert("Failed to update user status.", "error");
    } finally {
      setUpdatingUserId(null);
    }
  };

  if (loading) {
    return <div className="users-loading">Loading users...</div>;
  }

  if (error) {
    return <div className="users-error">{error}</div>;
  }

  return (
    <div className="users-page">
      <h2>Users</h2>

      <div className="users-table-wrapper">
        <table className="users-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="6">No users found.</td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user.id}>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td>{user.status}</td>
                  <td>
                    <button
                      type="button"
                      onClick={() => handleToggleStatus(user)}
                      disabled={updatingUserId === user.id}
                    >
                      {updatingUserId === user.id
                        ? "Updating..."
                        : user.status === "ACTIVE"
                          ? "Block"
                          : "Unblock"}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
